import React from 'react';
import Dialog from '../../toolkit/dialog';
import FirmwareCreateDialog from './FirmwareCreateDialog';
import IconButton from '../widgets/icon-button/IconButton';
import Content from '../dashboard/Content';
import ConfirmDialog from '../widgets/dialog/ConfirmDialog';
import updateService from '../../services/update-service';

import './firmware.scss';

class ConfirmDeleteDialog extends ConfirmDialog {
  title = () => 'آیا میخواهید این ورژن را حذف کنید؟';
  message = () => {
    return (
      <div className="mr-auto">
        <button className="btn ant-btn ml-2" onClick={this.close}>خیر</button>
        <button className="btn ant-btn ant-btn-danger" onClick={this.deleteClickHandler}>حذف</button>
      </div>
    );
  };
  icon = () => 'alert';
  deleteClickHandler = () => {
    this.resolve(true);
    this.close();
  }
}

export default class FirmwarePage extends React.Component {

  state = {
    firmwares: []
  }

  render() {
    return (
      <Content title="خانه / لیست Firmware ها">
        <div className="firmware-page">
          <ul className="row">
            {this.state.firmwares.map(firmware => (
              <li className="col-xxl-3 col-lg-4 col-sm-6 col-12" key={firmware._id}>
                <div className="firmware-page-item">
                  <i className="far fa-microchip"></i>
                  <span className="mx-2">{firmware.type}</span>
                  <div className="d-flex align-items-center mr-auto">
                    <div className="buttons-group mx-2">
                      <a href={'/dashboard/firmwares/update/' + firmware._id}>
                        <i className="far fa-edit"></i>
                      </a>
                      <i
                        data-id={firmware._id}
                        className="far fa-trash"
                        onClick={this.onDeleteClicked}
                      ></i>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12 col-lg-2 col-md-3 mt-auto mb-2 mr-auto">
          <IconButton
            block
            text="افزودن"
            direction="rtl"
            icon="far fa-plus"
            onClick={this.onCreateClicked}
          />
        </div>
      </Content>
    );
  }

  componentDidMount = async () => {
    const firmwares = await updateService.fetch();
    this.setState({ firmwares });
  }

  onCreateClicked = () => {
    new Dialog({
      rtl: true,
      title: 'نوع Firmware جدید را وارد کنید',
      size: 'small',
      message: FirmwareCreateDialog,
      onResolve: this.onSubmitCreate
    }).show();
  }

  onDeleteClicked = (e: React.MouseEvent) => {
    const id = (e.target as HTMLElement).getAttribute('data-id');
    new Dialog({
      size: 'small',
      rtl: true,
      showTitle: false,
      message: ConfirmDeleteDialog,
      onResolve: async (value: boolean) => {
        if (!value) return;
        try {
          await updateService.remove(id);
          this.componentDidMount();
        }
        catch (e) {
          alert(e.message);
          console.error(e);
        }
      }
    }).show()
  }

  onSubmitCreate = async (state: any) => {
    try {
      await updateService.create(state.type);
      this.componentDidMount();
    }
    catch (e) {
      console.log(e);
    }
  }

}
